<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content container-sm" style="margin-left: auto !important;">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <!-- <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul> -->
    <!--/ Menu Toggler -->

    <!-- Toggle skin -->
    <!-- <li class="nav-item d-none d-lg-block">
      <a type="button" class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li> -->
    <!--/ Toggle skin -->
    
    <li class="nav-item d-flex">
      <a routerLink="/">
        <picture>
          <img class="img-fluid" src="assets/images/misc/logo.png" alt="CADGRAFICS ONE" style="max-width: 266px; max-height: 120px;">
        </picture>
      </a>
    </li>
  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- ? Language selection | Uncomment if needed-->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li> -->
    <!--/ Language selection -->
    <li *ngIf="currentUser?.user.is_data_filled" class="nav-item">
      <a role="button" class="btn btn-link d-flex align-items-center" style="gap: 5px;" (click)="toggleNotificationPanel()">
        <span [ngClass]="{'ringing': ringBell}">
          <i class="font-medium-3 notifications-bell-icon" data-feather="bell"></i>
        </span>
        <div *ngIf="notificationCount">
          <span class="badge badge-pill badge-primary">{{notificationCount}}</span>
        </div>
      </a>
    </li>

    <!-- User Dropdown -->
    <li *ngIf="currentUser" ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name font-weight-bolder">{{userName}}</span><span class="user-status">{{userDomain}}</span>
        </div>
        <span class="avatar">
          <span class="avatar-content">{{userInitials}}</span>
        </span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <a ngbDropdownItem [routerLink]="['/editar-perfil']"> Editar Perfil</a>
        <button class="w-100" (click)="logout()" ngbDropdownItem > Cerrar sesión</button>
      </div>
    </li>
    <!--/ User Dropdown -->

    <li class="nav-item d-none d-md-block ml-1">
      <div class="d-flex">
        <picture>
          <!-- <img class="img-fluid" src="assets/images/misc/logo_jal.webp" width="140" alt="Jalisco"> -->
        </picture>
      </div>
    </li>
  </ul>
</div>
